module.exports = __webpack_public_path__ + "img/logo.9139d60a.png";